import { createAction, props } from '@ngrx/store';
import { CreatePageRequest, Page, UpdatePageRequest } from '@models/page.model';

export enum PageActions {
  GET_PAGES = '[Pages] Get pages',
  GET_PAGES_SUCCESS = '[Pages] Pages fetched',
  GET_PAGES_FAILED = '[Pages] Cannot fetch pages',
  UPDATE_PAGE = '[Pages] Update page',
  UPDATE_PAGE_SUCCESS = '[Pages] Page updated',
  UPDATE_PAGE_FAILED = '[Pages] Cannot update page',
  CREATE_PAGE = '[Pages] Create page',
  CREATE_PAGE_SUCCESS = '[Pages] Page created',
  CREATE_PAGE_FAILED = '[Pages] Cannot create page',
  DELETE_PAGE = '[Pages] Delete page',
  DELETE_PAGE_SUCCESS = '[Pages] Page deleted',
  DELETE_PAGE_FAILED = '[Pages] Cannot delete page',
}

export const fetchPages = createAction(PageActions.GET_PAGES, props<{ payload: string }>());
export const pagesFetched = createAction(PageActions.GET_PAGES_SUCCESS, props<{
  payload: Page[]
}>());
export const cannotFetchPages = createAction(PageActions.GET_PAGES_FAILED, props<{ error: string }>());

export const updatePage = createAction(PageActions.UPDATE_PAGE, props<{
  webshopId: string,
  payload: UpdatePageRequest
}>());
export const pageUpdated = createAction(PageActions.UPDATE_PAGE_SUCCESS, props<{ payload: Page }>());
export const cannotUpdatePage = createAction(PageActions.UPDATE_PAGE_FAILED, props<{ error: string }>());

export const createPage = createAction(PageActions.CREATE_PAGE, props<{
  webshopId: string,
  payload: CreatePageRequest
}>());
export const pageCreated = createAction(PageActions.CREATE_PAGE_SUCCESS, props<{ payload: Page }>());
export const cannotCreatePage = createAction(PageActions.CREATE_PAGE_FAILED, props<{ error: string }>());

export const deletePage = createAction(PageActions.DELETE_PAGE, props<{
  webshopId: string,
  pageId: string
}>());
export const pageDeleted = createAction(PageActions.DELETE_PAGE_SUCCESS, props<{ payload: string }>());
export const cannotDeletePage = createAction(PageActions.DELETE_PAGE_FAILED, props<{ error: string }>());
